import { gql } from "@apollo/client";

// The questions of each step of a published review, as the library stores them, with what
// this review changed: removed sections (`removed` on a link) and hidden or reworded
// questions (`questionOverrides`). Removed sections and hidden questions are included, so the
// Questions tab can list them with "Show again" (TF-1697).
// `questionSet` is read without a step, so its `templateContextId` is null: these library-worded
// copies keep their plain cache entries, apart from the review-worded ones the form reads.
export default gql`
  fragment ReviewStepQuestions on AssessmentTemplateNode {
    id
    questionSetLinks {
      id
      ordinal
      isTalentIndicators
      removed
      questionSet {
        id
        templateContextId
        title
        sections {
          edges {
            node {
              id
              templateContextId
              pk
              title
              description
              questions {
                edges {
                  node {
                    id
                    templateContextId
                    question {
                      id
                      templateContextId
                      title
                      description
                      questionType
                      ... on TalentIndicatorAssessmentQuestionNode {
                        talentIndicator {
                          id
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    questionOverrides {
      questionId
      hidden
      title
      description
    }
  }

  query getReviewStepQuestions($complianceProgramId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      id
      performanceAssessmentTemplate {
        ...ReviewStepQuestions
      }
      managerAssessmentTemplate {
        ...ReviewStepQuestions
      }
      peerAssessmentTemplate {
        ...ReviewStepQuestions
      }
      engagementSurveyTemplate {
        ...ReviewStepQuestions
      }
    }
  }
`;
